"use strict";

window.$ = window.jQuery = require('./Vendors/jquery-1.11.2.min.js');

require('./Vendors/bootstrap.min.js');
require('./Vendors/jquery.validate.min.js');
require('./Vendors/jquery.validate.unobtrusive.min.js');
require('./Vendors/jquery.touchSwipe.min.js');
require('./mobile-navigation.js');
require('./learning-center.js');


(function ($) {

    var privacyPolicyPageClass = 'page-1432';

    $(document).ready(function () {
        $(".content ul, .content ol,.article ul, .article ol").addClass("has-js");
        $(".has-js li").wrapInner("<div></div>");

        // add location info back in; using #locationName in form was caching between clinics
        if ($('#245c60e1-d4f5-45c7-d8c0-67b94bc12f1f')) {
            $('#245c60e1-d4f5-45c7-d8c0-67b94bc12f1f').val($('.clinic-page .left-section h2').clone().children().remove().end().text());
        }

        // ajax the umbraco forms
        // form must be wrapped in a div with class "ajaxform" for the ajax to work. otherwise the form is submitted the usual way so that it can use the Umbraco "Go to page"
        $('.ajaxform .umbraco-forms-form form').on('submit', function (e) {
            e.preventDefault();

            var $form = $(this);

            if ($form.data('submitted') === true) {
                // Previously submitted - don't submit again
            } else {
                if ($form.valid()) {
                    // Mark it so that the next submit can be ignored
                    $form.data('submitted', true);
                    $form.addClass('working');

                    // Make ajax call form submission
                    $.ajax({
                        url: $form.attr('action'),
                        type: 'POST',
                        cache: false,
                        data: $form.serialize(),
                        success: function (result) {
                            //console.log(result);
                            var $scrollTarget = $(".umbraco-forms-container");

                            if ($scrollTarget) {
                                $('html,body').animate({ scrollTop: $scrollTarget.offset().top - 300 }, 'slow');
                            }
                            
                            var $thankYouMessage = $(result).find('.umbraco-forms-submitmessage');
                            $form.parent().append($thankYouMessage);
                            $form.remove();
                            $('p.form-hide-submit').hide();

                            // Refresh the page after N seconds if we just submitted the event form
                            if ($('.event-form').length > 0) {
                                setTimeout(function () { location.reload(); }, 3000);
                            }
                        }
                    });
                }
            }
        });

        //Expose the newsletter captcha sign up on focus
        $('.newsletter input[type=text]').on('focus', function () {
            $('.spamverification').css('height', 'auto');
            $('#prefooter #prefooter-card p').css('margin-bottom', 20);
        });

        $("#clinic-carousel").swipe({

            swipe: function (event, direction, distance, duration, fingerCount, fingerData) {

                if (direction == 'left') $(this).carousel('next');
                if (direction == 'right') $(this).carousel('prev');

            },
            allowPageScroll: "vertical"

        });

    });

    $(window).scroll(function () {
        if (window.innerWidth > 768 && window.innerWidth < 992) {

            if ($(window).scrollTop() > 70) {
                if ((" " + document.getElementById("find-therapy-sticky").className + " ").indexOf("active") == -1) {
                    document.getElementById("find-therapy-sticky").className = "active";
                } 
            } else {
                document.getElementById("find-therapy-sticky").className = "";
            }
        } else if (window.innerWidth >= 992 && window.innerWidth < 1200) {
            if ($(window).scrollTop() > 70) {
                if ((" " + document.getElementById("find-therapy-sticky").className + " ").indexOf("active") == -1) {
                    document.getElementById("find-therapy-sticky").className = "active";
                } 
            } else {
                document.getElementById("find-therapy-sticky").className = "";
            }
        } else if (window.innerWidth >= 1200 && window.innerWidth < 1600) {
            if ($(window).scrollTop() > 110) {

                if ((" " + document.getElementById("find-therapy-sticky").className + " ").indexOf("active") == -1) {
                    document.getElementById("find-therapy-sticky").className = "active";
                } 
            } else {
                document.getElementById("find-therapy-sticky").className = "";
            }
        } else if (window.innerWidth >= 1600) {
            if ($(window).scrollTop() > 125) {
                if ((" " + document.getElementById("find-therapy-sticky").className + " ").indexOf("active") == -1) {
                    document.getElementById("find-therapy-sticky").className = "active";
                }
            } else {
                document.getElementById("find-therapy-sticky").className = "";
            }
        }        
    });

})(jQuery);